import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import useStyles from '../useStyles';
import PropTypes from 'prop-types';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import renderHTML from 'react-render-html';
import moment from 'moment';

function Step2({ jobAdParams, answers, setActiveStep }) {
  const [isMobile, setIsMobile] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={classes.stepContainer}>
      <h4>Preview Ad</h4>

      <div className={`${classes.previewType} ${isMobile ? 'mobile' : ''}`}>
        <div onClick={() => setIsMobile(false)}>Desktop</div>
        <div onClick={() => setIsMobile(true)}>Mobile</div>
      </div>

      <div className={`${classes.previewContainer} ${isMobile ? 'mobile' : ''}`}>
        <div className={classes.previewTitle}>{answers.jobTitle}</div>
        <div
          className={classes.previewDetails}
        >{`${jobAdParams.company_name} ${jobAdParams.address}`}</div>
        <div className={classes.previewButtons}>
          <div>Apply Now</div>
          <div>
            <FavoriteBorderIcon />
          </div>
        </div>
        <div className={classes.previewContent}>{renderHTML(answers.ad_preview)}</div>
      </div>

      <div className={`${classes.large}`}>
        <div className={classes.applicationSettings}>
          <h4>Application settings</h4>
          <span onClick={() => setActiveStep(0)}>Edit</span>
        </div>
        <Grid container classes={{ root: classes.greyBox }}>
          <Grid container classes={{ root: classes.applicationSettingsInner }}>
            <Grid item xs={8}>
              Resume:
            </Grid>
            <Grid item xs={4}>
              {answers.submitResume === 'required' && 'Required document'}
              {answers.submitResume === 'optional' && 'Optional document'}
              {answers.submitResume === 'hidden' && 'Not required'}
            </Grid>
          </Grid>
          <Grid container classes={{ root: classes.applicationSettingsInner }}>
            <Grid item xs={8}>
              Application deadline:
            </Grid>
            <Grid item xs={4}>
              {answers.isApplicationDeadline
                ? moment(answers.applicationDeadline).format('LL')
                : 'No deadline'}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

Step2.propTypes = {
  setActiveStep: PropTypes.func.isRequired,
  jobAdParams: PropTypes.object.isRequired,
  answers: PropTypes.object.isRequired,
  setAnswers: PropTypes.func.isRequired
};

export default Step2;
